module.exports = __webpack_public_path__ + "assets/img/sabc_league_list_logo.png?b5723ea70a910ad0f95ac5535e8b5bec";